module.exports = __webpack_public_path__ + "static/media/zipsDemo.db013cd8.gif";